(function () {
  document.querySelectorAll('.ct-library').forEach(initLibrary);

  function initLibrary(root) {
    const cards = Array.from(root.querySelectorAll('[data-ct-template-card]'));
    const templateGrid = root.querySelector('[data-ct-template-grid]');
    const audioPanel = root.querySelector('[data-ct-audio-panel]');
    const categoryButtons = Array.from(root.querySelectorAll('[data-ct-category-button]'));
    const emptyState = root.querySelector('[data-ct-empty-state]');

    const drawer = root.querySelector('[data-ct-drawer]');
    const backdrop = root.querySelector('[data-ct-drawer-backdrop]');
    const closeButton = root.querySelector('[data-ct-close-drawer]');

    let lastTrigger = null;
    const initiallyActive = categoryButtons.find((button) => button.classList.contains('is-active')) || categoryButtons[0];
    let activeCategory = initiallyActive ? (initiallyActive.dataset.ctCategoryButton || 'audio') : 'audio';

    function applyCategory() {
      const showingAudio = activeCategory === 'audio';
      let visible = 0;

      if (audioPanel) audioPanel.hidden = !showingAudio;
      if (templateGrid) templateGrid.hidden = showingAudio;

      cards.forEach((card) => {
        const show = !showingAudio && card.dataset.category === activeCategory;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (emptyState) {
        emptyState.hidden = showingAudio || visible !== 0;
      }
    }

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.ctCategoryButton || 'audio';
        categoryButtons.forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });
        applyCategory();
      });
    });

    function setText(selector, value) {
      const element = root.querySelector(selector);
      if (element) element.textContent = value || '—';
    }

    function openDrawer(card, trigger) {
      if (!drawer || !backdrop) return;
      lastTrigger = trigger;

      setText('[data-ct-drawer-title]', card.dataset.title);
      setText('[data-ct-drawer-subtitle]', card.dataset.subtitle);
      setText('[data-ct-drawer-code]', card.dataset.code);
      setText('[data-ct-drawer-description]', card.dataset.description);
      setText('[data-ct-drawer-flat-size]', card.dataset.flatSize);
      setText('[data-ct-drawer-finished-size]', card.dataset.finishedSize);
      setText('[data-ct-drawer-extra-spec]', card.dataset.extraSpec);

      const download = root.querySelector('[data-ct-drawer-download]');
      if (download) {
        if (card.dataset.pdfUrl) {
          download.href = card.dataset.pdfUrl;
          download.hidden = false;
        } else {
          download.hidden = true;
          download.removeAttribute('href');
        }
      }

      backdrop.hidden = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ct-drawer-lock');
      document.body.classList.add('ct-drawer-lock');
      if (closeButton) closeButton.focus();
    }

    function closeDrawer() {
      if (!drawer || !backdrop) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.documentElement.classList.remove('ct-drawer-lock');
      document.body.classList.remove('ct-drawer-lock');
      if (lastTrigger) lastTrigger.focus();
    }

    root.querySelectorAll('[data-ct-open-drawer]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-ct-template-card]');
        if (card) openDrawer(card, button);
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    applyCategory();
  }
})();
